<template>
  <div id="Profile">
    <div class="settings_view">
      <div class="default_top">
        <div>
          <span>Profile</span>
        </div>
        <div>
          <button class="main_btn" v-if="profile_edit == false" @click="profile_edit = true">Edit</button>
          <button class="save_btn" v-if="profile_edit == true" @click="profile_edit = false">Save</button>
          <button
            class="delete_btn"
            v-if="profile_edit == true"
            @click="profile_edit = false"
          >Cancel</button>
        </div>
      </div>

      <div class="content_account">
        <div class="section">
          <div class="col-3 text-right">
            <span class="title">Name :</span>
          </div>
          <div class="col-9">
            <input type="text" value="Joseph Davis" :disabled="profile_edit == false" />
          </div>
        </div>
        <div class="section">
          <div class="col-3 text-right">
            <span class="title">Email :</span>
          </div>
          <div class="col-9">
            <input type="text" value="joseph@gmail.com" :disabled="profile_edit == false" />
          </div>
        </div>
        <div class="section">
          <div class="col-3 text-right">
            <span class="title">Phone Number :</span>
          </div>
          <div class="col-9">
            <input type="text" value="+1-202-555-0135" :disabled="profile_edit == false" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Profile",
  components: {},
  data() {
    return {
      profile_edit: false
    };
  },
  methods: {}
};
</script>
